import { StyleSheet, Text, View } from 'react-native';

import { colorSemantic, unisonColors } from '@/theme';

const BADGE_MAX_COUNT = 99;

interface CountBadgeProps {
  readonly count: number;
  readonly testID?: string;
}

export const CountBadge = ({ count, testID }: CountBadgeProps) => {
  if (count <= 0) {
    return null;
  }

  const label = count > BADGE_MAX_COUNT ? `${BADGE_MAX_COUNT}+` : String(count);

  return (
    <View pointerEvents="none" style={styles.badge} testID={testID}>
      <Text style={styles.label}>{label}</Text>
    </View>
  );
};

const styles = StyleSheet.create({
  badge: {
    alignItems: 'center',
    backgroundColor: colorSemantic.colorBgErrorStrong,
    borderRadius: 8,
    height: 16,
    justifyContent: 'center',
    minWidth: 16,
    paddingHorizontal: 4,
  },
  label: {
    color: unisonColors.white,
    fontSize: 10,
    fontWeight: '700',
    includeFontPadding: false,
    lineHeight: 12,
    textAlign: 'center',
  },
});
